import { render, staticRenderFns } from "./TableTickets.vue?vue&type=template&id=bf7f8dae&scoped=true&"
import script from "./TableTickets.vue?vue&type=script&lang=js&"
export * from "./TableTickets.vue?vue&type=script&lang=js&"
import style0 from "./TableTickets.vue?vue&type=style&index=0&id=bf7f8dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7f8dae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
